import { registerSW } from 'virtual:pwa-register';
import { reportClientError } from './telemetry';

/** check for a new build this often while the page stays open (§15 #498) */
const UPDATE_EVERY_MS = 30 * 60_000;

/**
 * Register the service worker (auto-update: a new build activates and the page reloads). Called
 * once from main.tsx in production builds. Besides the browser's own check on navigation, the
 * page asks for an update when it comes back to the front (a caddy's phone resumes the tab) and
 * every 30 minutes (§15 #498).
 */
export function setupPwa(): void {
  if (!import.meta.env.PROD) return;
  registerSW({
    immediate: true,
    onRegisteredSW: (_url, reg) => {
      if (!reg) return;
      const check = () => {
        if (navigator.onLine) reg.update().catch(() => undefined);
      };
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') check();
      });
      setInterval(check, UPDATE_EVERY_MS);
    },
    // a failing service worker means no offline shell for caddies in the field: report it
    onRegisterError: (err: unknown) => reportClientError('sw', err, { stage: 'register' }),
  });
}
